import { authRequest } from './utils';

/**
 * fetchSubscribeEmails :: Object -> Promise Error Object
 */
export const fetchSubscribeEmails = () => authRequest({
  method: 'GET',
  url: '/emails-list',
})
  .then(({ data }) => data);

/**
 * deleteSubscribeEmailById :: ID -> Promise Error Object
 */
export const deleteSubscribeEmailById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/emails-list/${_id}`,
  })
    .then(({ data: { email } }) => email);

/**
 * addSubscribeEmail :: Object -> Promise Error Contact
 */
export const addSubscribeEmail = data =>
  authRequest({
    method: 'POST',
    url: '/emails-list',
    data,
  })
    .then(({ data: { email } }) => email);



// WEBPACK FOOTER //
// ./src/api/apiko-api/subscribe-emails.js